import { $globalSanityDataloader } from './$globalSanityDataloader';

export const $globalSanityClient = Object.freeze({
  projectId: process.env.SANITY_ID,
  dataset: process.env.SANITY_DATASET ?? 'production',
  fetch: <T>(query: string, params?: any): Promise<T> =>
    $globalSanityDataloader.load({
      query,
      params
    }),
  config: () => ({
    projectId: process.env.SANITY_ID,
    dataset: process.env.SANITY_DATASET ?? 'production'
  })
});

export default $globalSanityClient;
